/**
 * @description Идентификатор действия копирования записи на прием.
 * @type {string}
 */
export const APPOINTMENT_COPY = 'APPOINTMENT_COPY';

/**
 * @description Отчистить скопированную запись.
 * @type {string}
 */
export const CLEAR_APPOINTMENT_COPY = 'CLEAR_APPOINTMENT_COPY';

/**
 * @description Идентификатор состояния количества заявок на прием.
 * @type {string}
 */
export const APPOINTMENT_ORDERS_COUNT = 'APPOINTMENT_ORDERS_COUNT';

/**
 * @description Загрузить скопированную запись.
 * @type {string}
 */
export const LOAD_APPOINTMENT_COPY = 'LOAD_APPOINTMENT_COPY';
